import { useTranslation } from 'react-i18next'
import NumberFormat from 'react-number-format'
import { Box, TextField } from '@mui/material'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

export const MinLineFilterType = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  return (
    <Box mt={1}>
      <NumberFormat
        name="minLine"
        customInput={TextField}
        prefix="+"
        type="text"
        label={t('restrictions.minLine')}
        thousandSeparator=","
        onValueChange={({ value: v }) => handleChangeSearch('minLine', v)}
      />
    </Box>
  )
}
